import { render, staticRenderFns } from "./billsPayment.vue?vue&type=template&id=6d0bd142"
import script from "./billsPayment.vue?vue&type=script&lang=js"
export * from "./billsPayment.vue?vue&type=script&lang=js"
import style0 from "./billsPayment.vue?vue&type=style&index=0&id=6d0bd142&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports